import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "letter-spacings"
    }}><a parentName="h3" {...{
        "href": "#letter-spacings",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Letter Spacings`}</h3>
    <p>{`If you'd like to customize your values for letter spacings, use the `}<inlineCode parentName="p">{`theme.letterSpacings`}</inlineCode>{` section of your theme.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-diffjs"
      }}>{`  // theme.js
  export const theme = {
    letterSpacings: {
+     tightest: '-.075em',
      tighter: '-.05em',
-     tight: '-.025em',
      normal: '0',
-     wide: '.025em',
      wider: '.05em',
-     widest: '.1em',
+     widest: '.25em',
    },
  }
`}</code></pre>
    <p>{`If you don't want to customize it, a set of `}<inlineCode parentName="p">{`letterSpacings`}</inlineCode>{` is already defined in default theme:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const defaultTheme = {
  // ...
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      